var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiPortCruiseSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "320px",
    y: "248px",
    height: "320px",
    width: "248px",
    viewBox: "-467 265 24.8 32",
    style: {
      enableBackground: "new -467 265 24.8 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n          fill: #FFFFFF;\n\t\t}\n\n\t\t.st1 {\n\t\t\tfill: #405D88;\n\t\t}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-460,288.8 -466,288.8 -466,266 -443.2,266 -443.2,288.8 -449.2,288.8 -454.6,295.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-444.2,267v10.4v10.4h-4.5h-0.9l-0.6,0.7l-4.4,5.3l-4.4-5.3l-0.6-0.7h-0.9h-4.5V267H-444.2 M-442.2,265H-467 v24.8h6.5l5.9,7.2l5.9-7.2h6.5v-12.4V265L-442.2,265z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-450,279c-0.7,1.6-2.1,2.7-3.9,3v-6.9h3.1v-1.5h-3.1v-2.3h-1.5v2.4h-3.1v1.5h3.1v6.8c-1.7-0.3-3.2-1.4-3.9-3 l-1.3,0.6l0,0c1,2.3,3.2,3.9,5.9,3.9c2.7,0,4.9-1.6,5.9-3.9L-450,279z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiPortCruiseSelected);
export default __webpack_public_path__ + "static/media/ri-port-cruise-selected.92310e71cf6e7f5be19a712df28ef7cc.svg";
export { ForwardRef as ReactComponent };